import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marche from "@/components/landing/Marche";
import Marquee from "@/components/landing/Marquee";
import Scarcity from "@/components/landing/Scarcity";
import Manifesto from "@/components/landing/Manifesto";
import Calculator from "@/components/landing/Calculator";
import Stats from "@/components/landing/Stats";
import LeadForm from "@/components/landing/LeadForm";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#070C0A] text-slate-100">
      <div className="grain" />
      <Nav />
      <main>
        <Hero />
        <Marche />
        <Marquee />
        <Scarcity />
        <Manifesto />
        <Calculator />
        <Stats />
        <LeadForm />
        <Faq />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
